const tabs = [
    {
        id: 1,
        label: "home",
        key: "HOME",
    },
    {
        id: 2,
        label: "about",
        key: "ABOUT",
    },
    {
        id: 3,
        label: "conferences",
        key: "CONFERENCES",
    },
    {
        id: 4,
        label: "journal",
        key: "JOURNAL",
    },
    {
        id: 5,
        label: "etc",
        key: "ETC",
    },
];

export default tabs;